import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationSoundService {
  private audio: HTMLAudioElement | null = null;

  prime(source = '/assets/audio/new-order.mp3'): void {
    if (!this.ensureAudio(source) || !this.audio) {
      return;
    }

    this.audio.load();
  }

  async play(source = '/assets/audio/new-order.mp3'): Promise<void> {
    if (!this.ensureAudio(source) || !this.audio) {
      return;
    }

    try {
      this.audio.currentTime = 0;
      await this.audio.play();
    } catch {
      // autoplay pode ser bloqueado; notificações visuais continuam operando
    }
  }

  private ensureAudio(source: string): boolean {
    if (typeof window === 'undefined' || typeof Audio === 'undefined') {
      return false;
    }

    if (!this.audio || this.audio.src !== source) {
      this.audio = new Audio(source);
      this.audio.preload = 'auto';
    }

    return true;
  }
}
